import { EditorialErrorIdentifier } from '@/components/EditorialErrors/EditorialErrors';
import { convertStrapiSingleMediaOrArrayToMediaArray } from '@/lib/apiTypes';

const identifyTooLongAltText: EditorialErrorIdentifier = ({ useSpecies }) => {
	const { species } = useSpecies;
	if (!species) return [];

	const mediaAlts: {
		speciesId: number;
		speciesName: string;
		srcUrl: string;
		altText: string;
		mediaType: 'image' | 'audio';
	}[] = [];

	// Look through the main image and images added to the descriptions
	species.data.forEach((species) => {
		// Get alt text from main image
		convertStrapiSingleMediaOrArrayToMediaArray(
			species.attributes.imageMain,
		).forEach((media) => {
			mediaAlts.push({
				speciesId: species.id,
				speciesName: species.attributes.titleShort,
				srcUrl: media.url,
				altText: media?.alternativeText ?? '',
				mediaType: media.mime.split('/')[0] as 'image' | 'audio',
			});
		});
		// Get alt text for every description
		Object.entries(species.attributes.speciesDescription).forEach(
			([, description]) => {
				if (typeof description === 'number') return;
				convertStrapiSingleMediaOrArrayToMediaArray(
					description.media,
				).forEach((media) => {
					if (!media.alternativeText) {
						mediaAlts.push({
							speciesId: species.id,
							speciesName: species.attributes.titleShort,
							srcUrl: media.url,
							altText: media?.alternativeText ?? '',
							mediaType: media.mime.split('/')[0] as
								| 'image'
								| 'audio',
						});
					}
				});
			},
		);
	});

	// Get every alt text ends with a period or is less than 200 characters:
	const errors = mediaAlts
		.filter(
			(mediaItem) =>
				!mediaItem.altText.endsWith('.') &&
				mediaItem.altText.length > 240,
		)
		.map((mediaItem) => ({
			speciesId: mediaItem.speciesId,
			title: 'Alternatieve tekst mogelijk te lang',
			description: (
				<>
					{mediaItem.speciesName} heeft een{' '}
					<a
						href={mediaItem.srcUrl}
						target="_blank"
						className="text-secondary underline">
						item
					</a>{' '}
					met alternatieve tekst die mogelijk te lang is (maximaal 256
					tekens). Zorg dat de alt tekst eindigt met een punt:
					<br />
					<br />
					<span className="font-medium">"{mediaItem.altText}"</span>
				</>
			),
		}));

	return errors;
};

export default identifyTooLongAltText;
